import React, { useState } from 'react';
import './Calculator.css';

function Calculator({ onClose }) {
  const [display, setDisplay] = useState('0');
  const [pending, setPending] = useState(null); // { value, op }
  const [overwrite, setOverwrite] = useState(true);

  const inputDigit = (digit) => {
    if (overwrite) {
      setDisplay(digit);
      setOverwrite(false);
    } else {
      setDisplay(display === '0' ? digit : display + digit);
    }
  };

  const inputDecimal = () => {
    if (overwrite) {
      setDisplay('0.');
      setOverwrite(false);
      return;
    }
    if (!display.includes('.')) setDisplay(display + '.');
  };

  const clearAll = () => {
    setDisplay('0');
    setPending(null);
    setOverwrite(true);
  };

  const compute = (a, b, op) => {
    switch (op) {
      case '+': return a + b;
      case '-': return a - b;
      case '×': return a * b;
      case '÷': return b === 0 ? NaN : a / b;
      default: return b;
    }
  };

  const chooseOperator = (op) => {
    const current = parseFloat(display);
    if (pending) {
      const result = compute(pending.value, current, pending.op);
      setDisplay(String(result));
      setPending({ value: result, op });
    } else {
      setPending({ value: current, op });
    }
    setOverwrite(true);
  };

  const equals = () => {
    if (!pending) return;
    const current = parseFloat(display);
    const result = compute(pending.value, current, pending.op);
    setDisplay(String(result));
    setPending(null);
    setOverwrite(true);
  };

  const toggleSign = () => setDisplay(String(parseFloat(display) * -1));

  const buttons = [
    ['C', '±', '÷'],
    ['7', '8', '9', '×'],
    ['4', '5', '6', '-'],
    ['1', '2', '3', '+'],
    ['0', '.', '='],
  ];

  const handleButton = (label) => {
    if (/[0-9]/.test(label)) return inputDigit(label);
    if (label === '.') return inputDecimal();
    if (label === 'C') return clearAll();
    if (label === '±') return toggleSign();
    if (label === '=') return equals();
    return chooseOperator(label);
  };

  return (
    <div className="calculator-overlay" onClick={onClose}>
      <div className="calculator" onClick={(e) => e.stopPropagation()}>
        <div className="calculator-header">
          <span>Calculator</span>
          <button className="calculator-close" onClick={onClose} aria-label="Close calculator">×</button>
        </div>
        <div className="calculator-display">{display}</div>
        <div className="calculator-keys">
          {buttons.map((row, i) => (
            <div className="calculator-row" key={i}>
              {row.map((label) => (
                <button
                  key={label}
                  className={`calculator-key ${['+', '-', '×', '÷', '='].includes(label) ? 'calculator-key-op' : ''}`}
                  onClick={() => handleButton(label)}
                >
                  {label}
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Calculator;
